import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link, match } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { SituationForm } from 'types';
import Layout from '../../components/templates/layout';
import { useIntl } from '../../common/config/i18n';
import {
  SituationActions,
  SituationsSelectors,
  SituationSelectors,
  ClearStateSliceActions,
} from '../../common/config/store';
import history from '../../app-router/history';
import FormSituation from '../../components/templates/form-situation';
import Card from '../../components/molecules/card';

const Wrapper = styled.div`
  margin: 5px;
`;
const StyledBreadcrumbWrapper = styled.div`
  margin: 10px 0 20px 20px;
`;
interface Props {
  match: match<Params>;
}
interface Params {
  id: string;
}
const SituationPage: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { t } = useIntl();
  const { id } = props.match.params;
  const situationId = Number(id);
  const status = useSelector(SituationSelectors.statusSelector);
  const error = useSelector(SituationSelectors.errorSelector);

  useEffect(() => {
    return () => {
      dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'Situation', sliceKey: 'error' }));
      dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'Situation', sliceKey: 'status' }));
    };
  }, [dispatch]);

  const onSubmitHandler = (values: SituationForm) => {
    if (situationId) {
      dispatch(
        SituationActions.updateSituation(
          {
            ...values,
            id: situationId,
          },
          (result) => {
            if (!result.cancelled && !result.error) {
              history.push('/situations');
            }
          }
        )
      );
    } else {
      dispatch(
        SituationActions.createSituation(values, (result) => {
          if (!result.cancelled && !result.error) {
            history.push('/situations');
          }
        })
      );
    }
  };
  const title = situationId ? t('SituationPage', 'SITUATION_UPDATE') : t('SituationPage', 'SITUATION_CREATE');
  const situations = useSelector(SituationsSelectors.situationsSelector);
  const situation = situationId ? situations.find((situation) => situation.id === situationId) : undefined;

  return (
    <div>
      <Layout />
      <Wrapper>
        <StyledBreadcrumbWrapper>
          <Link to="/situations">{t('SituationPage', 'SITUATION_BACK')}</Link>
        </StyledBreadcrumbWrapper>

        <Card title={title}>
          <FormSituation situation={situation} onSubmit={onSubmitHandler} error={error} status={status} />
        </Card>
      </Wrapper>
    </div>
  );
};

export default SituationPage;
